import { useState } from "react";
import { Box,Typography } from "@mui/material";
import { Routes,Route,Navigate,useNavigate } from "react-router-dom";
import { useAppTheme } from "../../context/ThemeContext";
import { useAuth } from "../../context/AuthContext";
import Sidebar from "./DelegateDashboard/Sidebar";
import TopBar from "./DelegateDashboard/TopBar";
import Team from "./DelegateDashboard/Team";
import AdminPlayers from "./AdminPlayers";
import AdminTournaments from "./AdminTournaments";
import AdminMatches from "./AdminMatches";
import futbolito from "../../static/futbolito.png";

function DelegateHome(){
  const navigate=useNavigate();
  const {colors,typography,shape}=useAppTheme();
  const {user}=useAuth();

  const nombre=user?.nombre_completo||user?.first_name||"Delegado";

  const cardSx={
    p:2,
    width:"100%",
    maxWidth:360,
    minHeight:125,
    border:`1px solid ${colors.border}`,
    borderRadius:shape.radiusLarge,
    backgroundColor:colors.surface,
    cursor:"pointer",
    transition:"border-color .2s ease, background-color .2s ease",
    "&:hover":{
      borderColor:colors.secondary,
      backgroundColor:colors.backgroundSoft,
    },
  };

  const quickAccess=[
    {
      title:"Jugadores",
      description:"Registra y administra los jugadores de tu equipo por categoría.",
      path:"/delegado/jugadores",
    },
    {
      title:"Torneos",
      description:"Consulta los torneos, fases, grupos y rivales de tu equipo.",
      path:"/delegado/torneos",
    },
    {
      title:"Partidos",
      description:"Consulta los próximos partidos y el calendario de tu equipo.",
      path:"/delegado/partidos",
    },
  ];

  return (
    <Box sx={{width:"100%",maxWidth:1300,mx:"auto"}}>
      <Box
        sx={{
          width:"100%",
          mb:3,
          px:{xs:2,sm:3},
          py:{xs:2.5,sm:3},
          display:"flex",
          alignItems:"center",
          gap:{xs:2,sm:3},
          border:`1px solid ${colors.border}`,
          borderRadius:shape.radiusLarge,
          backgroundColor:colors.surface,
          overflow:"hidden",
        }}
      >
        <Box
          sx={{
            width:{xs:85,sm:120},
            minWidth:{xs:85,sm:120},
            height:{xs:85,sm:120},
            display:"flex",
            alignItems:"center",
            justifyContent:"center",
          }}
        >
          <Box
            component="img"
            src={futbolito}
            alt="Fútbol"
            sx={{
              width:"100%",
              height:"100%",
              objectFit:"contain",
              display:"block",
            }}
          />
        </Box>

        <Box sx={{minWidth:0}}>
          <Typography
            sx={{
              mb:0.5,
              fontSize:typography.sizes.sm,
              fontWeight:typography.weights.bold,
              color:colors.textSecondary,
            }}
          >
            PANEL DE DELEGADO
          </Typography>

          <Typography
            sx={{
              fontSize:{xs:typography.sizes.xl,md:typography.sizes.pageTitle},
              fontWeight:typography.weights.extraBold,
              color:colors.text,
              lineHeight:1.2,
            }}
          >
            Bienvenido, {nombre}
          </Typography>

          <Typography
            sx={{
              mt:0.8,
              maxWidth:650,
              fontSize:typography.sizes.md,
              lineHeight:1.55,
              color:colors.textSecondary,
            }}
          >
            Administra los jugadores de tu equipo y consulta los torneos, rivales y próximos partidos desde un solo lugar.
          </Typography>
        </Box>
      </Box>

      <Typography sx={{mb:1.5,fontSize:typography.sizes.xl,fontWeight:typography.weights.bold,color:colors.text}}>
        Accesos rápidos
      </Typography>

      <Box
        sx={{
          display:"grid",
          gridTemplateColumns:{xs:"1fr",sm:"repeat(2,minmax(0,360px))",lg:"repeat(3,minmax(0,360px))"},
          gap:1.5,
          justifyContent:"start",
        }}
      >
        {quickAccess.map((item)=>(
          <Box key={item.path} onClick={()=>navigate(item.path)} sx={cardSx}>
            <Typography sx={{fontSize:typography.sizes.lg,fontWeight:typography.weights.bold,color:colors.text}}>
              {item.title}
            </Typography>

            <Typography sx={{mt:0.7,fontSize:typography.sizes.md,lineHeight:1.5,color:colors.textSecondary}}>
              {item.description}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export default function DelegateDashboard(){
  const {colors}=useAppTheme();

  const [sidebarExpanded,setSidebarExpanded]=useState(
    ()=>localStorage.getItem("delegateSidebarExpanded")!=="false"
  );

  const [mobileOpen,setMobileOpen]=useState(false);

  const handleToggleSidebar=()=>{
    setSidebarExpanded(current=>{
      const next=!current;
      localStorage.setItem("delegateSidebarExpanded",String(next));
      return next;
    });
  };

  return (
    <Box sx={{display:"flex",width:"100%",minHeight:"100vh",backgroundColor:colors.background}}>
      <Sidebar expanded={sidebarExpanded} mobileOpen={mobileOpen} onMobileClose={()=>setMobileOpen(false)} />

      <Box sx={{flex:1,minWidth:0,minHeight:"100vh",display:"flex",flexDirection:"column",backgroundColor:colors.background}}>
        <TopBar sidebarExpanded={sidebarExpanded} onToggleSidebar={handleToggleSidebar} onOpenMobile={()=>setMobileOpen(true)} />

        <Box component="main" sx={{flex:1,p:{xs:1.5,sm:2,md:3},backgroundColor:colors.background}}>
          <Routes>
            <Route index element={<DelegateHome />} />
            <Route path="equipo" element={<Team />} />
            <Route path="jugadores" element={<AdminPlayers />} />
            <Route path="torneos" element={<AdminTournaments />} />
            <Route path="partidos" element={<AdminMatches />} />
            <Route path="*" element={<Navigate to="/delegado" replace />} />
          </Routes>
        </Box>
      </Box>
    </Box>
  );
}